/**
 * Generated runtime TestId mirror for frontend/src/components/time-switch.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const TimeSwitchTestIds = {
  btnAdvance1Day: "btn-advance-1-day",
  btnAdvance30Days: "btn-advance-30-days",
  btnAdvance7Days: "btn-advance-7-days",
  btnResetTime: "btn-reset-time",
  btnSetTime: "btn-set-time",
  btnTimeSwitch: "btn-time-switch",
  timeSwitchInput: "time-switch-input"
} as const;
